import React from "react";
import HeroSm from "../../components/HeroSm/HeroSm";
import Section from "../../components/Section/Section";
import MainLayout from "../../layouts/MainLayout";
import ImageCardBox from "../../components/ListitemForSaleComponents/ImageCardBox";
import ButtonSelection from "../../components/ListitemForSaleComponents/ButtonSelection";
import cardimg from "../ListItemForSale2/auth-left-signup.png";
import graphimg from "../ListItemForSale2/graphimg.PNG";
import noofferyet from "../ListItemForSale2/noofferyet.png";

const ListItemForSale2 = () => {
  return (
    <MainLayout>
      <Section id="listitemforsale">
        <div className="listitemforsale2-section1">
          <div class="">
            <div class="row">
              <div class="col col-imgcontainer">
                <img src={cardimg} alt="" />
              </div>
              <div class="col col-collectioncontainer">
                <h5>United Collection #2342115436</h5>
                <h4>Item Name</h4>
                <br />
                <br />
                <br />
                <br />
                <br />
                <h5>
                  Owned By <span style={{ color: "blue" }}>You</span>
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div className="listitemforsale2-section2 mt-4">
          <div class="">
            <div class="row">
              <div
                class="col col-desc mr-1"
                style={{ marginRight: "5px", marginLeft: "9px" }}
              >
                <div className="boxhead">
                  <h6>Description</h6>
                </div>
                <h6 style={{ padding: "15px" }}>
                  United Collection #2342115436
                </h6>
                <h5 style={{ padding: "15px" }}>
                  Owned By <span style={{ color: "blue" }}>You</span>
                </h5>
                <div className="boxhead">
                  <h6>About United Collection #2342115436</h6>
                </div>
                <div className="boxhead">
                  <h6>Details</h6>
                </div>
              </div>
              <div class="col col-desc" style={{ marginLeft: "5px" }}>
                <div className="boxhead">
                  <h6>Price History</h6>
                </div>

                <img
                  src={graphimg}
                  alt=""
                  style={{
                    width: "45%",
                    margin: "auto 177px",
                    padding: "20px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className=" listitemforsale2-section3 mt-4">
        <div className="boxhead">
                  <h6>Listings</h6>
                </div>
        </div>

        <div className=" listitemforsale2-section4 mt-4">
        <div className="boxhead">
                  <h6>Offers</h6>
                </div>
                <div className="text-center">
                <img
                  src={noofferyet}
                  style={{
                    width: "45%",
                    padding: " 50px 50px 0px 50px;",
                  }}
                />
                <h5 style={{color:"grey"}}>No Offers Yet</h5>
                </div>
        </div>

        <div className=" listitemforsale2-section5 mt-4">
        <div className="boxhead">
                  <h6>Item Activity</h6>
                </div>
                <select className="filterselect">Filter
                <option selected>Filter</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                </select>
                <div className="row itemactivity-tablehead" >
                    <div className="col">Event</div>
                    <div className="col">Price</div>
                    <div className="col">From</div>
                    <div className="col">To</div>
                    <div className="col">Date</div>
                </div>

                <div className="row itemactivity-tabledata" >
                    <div className="col">Minted</div>
                    <div className="col">0</div>
                    <div className="col">Null Address</div>
                    <div className="col">You</div>
                    <div className="col">20 Mins</div>
                </div>
        </div>

        <div className="listitemforsale2-section6 mt-4">
        <div className="boxhead">
                  <h6>More From This Collection</h6>
                </div>
                  <div className="text-center">
                <button type="button" class="btn btnViewCollection">
        View Collection
      </button>
      </div>

                </div>

      </Section>
    </MainLayout>
  );
};

export default ListItemForSale2;
